import { styledOmitCustomProps } from '@braskai/ui-kit';

import { Box, css, IconButton, styled } from '@mui/material';

import UpgradeGradientBg from '@/shared/assets/images/upgrade-modal-gradient.png';

export const SModalContainer = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.palette.common.white};
    border-radius: 20px;
    padding: 16px;
    width: 100%;

    ${theme.breakpoints.up('tablet')} {
      padding: 24px;
    }
  `,
);

export const SHeader = styled(Box)(
  () => css`
    margin-top: 4px;
    margin-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
);

export const SCloseButton = styled(IconButton)(
  ({ theme }) => css`
    color: ${theme.palette.grey[500]};
    height: 24px;
    padding: 0;
    width: 24px;
  `,
);

export const SContent = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
);

export const SPlanBlock = styled(
  Box,
  styledOmitCustomProps,
)<{ $isNewPlan?: boolean }>(
  ({ theme, $isNewPlan }) => css`
    border: 1px solid ${$isNewPlan ? theme.palette.primary[100] : theme.palette.grey[200]};
    border-radius: 12px;
    padding: 16px;
    background-color: ${$isNewPlan ? theme.palette.primary[25] : 'transparent'};
    background-image: ${$isNewPlan ? `url(${UpgradeGradientBg})` : 'none'};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,
);

export const SPlanLabel = styled(
  Box,
  styledOmitCustomProps,
)<{ $isNewPlan?: boolean }>(
  ({ theme, $isNewPlan }) => css`
    display: flex;
    align-items: center;
    color: ${$isNewPlan ? theme.palette.primary[500] : theme.palette.grey[500]};
  `,
);

export const SButtonContainer = styled(Box)(
  ({ theme }) => css`
    margin-top: 16px;

    ${theme.breakpoints.up('tablet')} {
      margin-top: 24px;
    }
  `,
);
